import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmNotNowClickedPayload {
  candidateId?: string;
}

/**
 * Fires when the user clicks "Not Now" on the bulk "Confirm Shifts" page.
 * Event: dental_portal:bulk_confirm:not_now_clicked
 */
export function fireBulkConfirmNotNowClicked(
  payload: IBulkConfirmNotNowClickedPayload = {},
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:not_now_clicked', {
    candidate_id: payload.candidateId,
  });
}
